import { useState } from 'react';

export const CostumHook = () => {
  const [pValue] = useState(20);
  const [sValue] = useState(12);

  return (
    <div>
      <code>{"import React, { useState, useEffect } from 'react';"}</code>
      <br />
      <code>{"import axios from 'axios';"}</code>
      <br />
      <br />
      <code>{"const useApi = (url, method = 'get', body = null, headers = {}) => {"}</code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'const [data, setData] = useState(null);'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'const [loading, setLoading] = useState(true);'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'const [error, setError] = useState(null);'}
      </code>
      <br />
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{'useEffect(() => {'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>
        {'const fetchData = async () => {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'try {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {"const response = await axios({ method, url, data: body, headers });"}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'setData(response.data);'}{' '}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'} catch (error) {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'setError(error);'}{' '}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'} finally {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'setLoading(false);'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'}'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>{'};'}</code>
      <br />
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>
        {'fetchData();'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{'}, [url, method, body, headers])'} </code>
      <br />
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{'return { data, loading, error };'}</code>
      <br />
      <br />
      <code>{'export default useApi;'}</code>
    </div>
  );
};
